import type { Pagination, Substitution } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/substitutions';

export function getSubstitutions(query: Substitution.SearchQuery) {
    return api.get<Pagination<Substitution>>(`${rootPath}`, query);
}

export function getSubstitution(id: number) {
    return api.get<Substitution.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postSubstitution(data: Substitution.CreateRequest) {
    return api.post<Substitution>(`${rootPath}`, data);
}

export function putSubstitution(id: number, data: Substitution.UpdateRequest) {
    return api.put<Substitution>(`${rootPath}/${id}`, data);
}

export function deleteSubstitution({ id }: Substitution.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
